import { Input, Label } from "@monsterindia/global-ui-components";
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormGetValues,
  UseFormRegister,
  UseFormResetField,
  UseFormSetValue,
} from "react-hook-form";

import { CheckboxOptionType, DropdownOptionType } from "../../../types";
import { SingleDropDownController } from "../../controllers";
import { containsOther } from "./getSubmitData";

type SpecializationFieldsProps = {
  control: Control<FieldValues, any>;
  getValues: UseFormGetValues<FieldValues>;
  errors: FieldErrors<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  register: UseFormRegister<FieldValues>;
  resetField: UseFormResetField<FieldValues>;
  clearErrors: (field: string) => void;
  specializationData: CheckboxOptionType[] | null;
  collegeData: CheckboxOptionType[] | null;
  specializationDropdownOptionsHandler: (inputText: string) => void;
  collegeDropdownOptionsHandler: (inputText: string) => void;
  isSpecificationDisabled: boolean;
  setManualSpecialization: (value: boolean) => void;
  setManualInstitute: (value: boolean) => void;
  manualSpecialization: boolean;
  manualInstitute: boolean;
  isDropdownOptionLoading: boolean;
};

export const SpecializationFields = ({
  control,
  getValues,
  clearErrors,
  errors,
  setValue,
  resetField,
  register,
  specializationData,
  collegeData,
  specializationDropdownOptionsHandler,
  collegeDropdownOptionsHandler,
  isSpecificationDisabled,
  setManualSpecialization,
  setManualInstitute,
  manualSpecialization,
  manualInstitute,
  isDropdownOptionLoading,
}: SpecializationFieldsProps) => {
  return (
    <>
      {specializationData && specializationData.length > 0 && (
        <>
          <Label
            labelText="Specialization/Major"
            isRequired={true}
            className="!l1-text-sm"
            htmlFor="specialization"
          >
            <SingleDropDownController
              name="specialization"
              control={control}
              isRequired={true}
              placeholder="Select your specialization"
              isSearchable={true}
              options={specializationData ?? []}
              isLoading={isDropdownOptionLoading}
              isDisabled={
                isSpecificationDisabled || !getValues("highestQualification")
              }
              // onChangeHandler={(inputText: string) => {
              //   specializationDropdownOptionsHandler(inputText);
              // }}
              onSelect={(value: DropdownOptionType) => {
                clearErrors("specialization");
                setValue("specialization", value);
                if (value && value.text) {
                  setManualSpecialization(containsOther(value.text));
                }
                resetField("manualSpecialization");
                // resetField("institute");
                // resetField("university");
              }}
              errorMessage={
                !isSpecificationDisabled
                  ? errors.specialization
                    ? "This field is required"
                    : ""
                  : undefined
              }
            />
          </Label>

          {manualSpecialization ? (
            <Label
              labelText="Enter Your Specialization"
              isRequired={true}
              className="!l1-text-sm"
            >
              <Input
                id="manualSpecialization"
                placeholder="Enter Your Specialization"
                {...register("manualSpecialization", {
                  required: true,
                  minLength: {
                    value: 2,
                    message: "Please enter a valid specialization",
                  },
                  maxLength: {
                    value: 150,
                    message: "You have reached maximum limit of 150",
                  },
                })}
                errorText={
                  errors.manualSpecialization
                    ? errors.manualSpecialization.message ||
                      "This field is required"
                    : ""
                }
              />
            </Label>
          ) : null}
        </>
      )}

      <Label
        labelText="University/Institute"
        isRequired={true}
        className="!l1-text-sm"
      >
        <SingleDropDownController
          name="institute"
          control={control}
          isRequired={true}
          placeholder="Select your University"
          isSearchable={true}
          options={collegeData ?? []}
          isLoading={isDropdownOptionLoading}
          onChangeHandler={(inputText: string) => {
            collegeDropdownOptionsHandler(inputText);
          }}
          onSelect={(value: DropdownOptionType) => {
            clearErrors("institute");
            setValue("institute", value);
            if (value && value.text) {
              setManualInstitute(containsOther(value.text));
            }
            // resetField("university");
          }}
          errorMessage={errors.institute ? "This field is required" : ""}
        />
      </Label>

      {manualInstitute ? (
        <Label
          labelText="Enter Your University/Institute"
          isRequired={true}
          className="!l1-text-sm"
        >
          <Input
            id="university"
            placeholder="Enter Your University/Institute"
            {...register("university", {
              required: true,
              minLength: {
                value: 2,
                message: "Please enter a valid university/institute",
              },
              maxLength: {
                value: 100,
                message: "You have reached maximum limit of 100",
              },
            })}
            errorText={
              errors.university
                ? errors.university.message || "This field is required"
                : ""
            }
          />
        </Label>
      ) : null}
    </>
  );
};
